// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"81c789a0","82":"e73e32c5","291":"af671f27","498":"6eb2a0a4","900":"3bcca2e6"}[chunkId] + ".chunk.js";
};